import { Stack, Typography } from "@mui/material";
import { ProgressButton, AlertBanner } from "@qubit/autoparts";

import { useTranslation } from "react-i18next";

import { ASDSThemeProvider } from "~/components/designSystem/ASDSThemeProvider";

type ErrorAlertBannerProps = {
  title: string;
  message: string;
  retryButtonText?: string;
  onRetry?: () => Promise<void> | void;
  isRetryActionLoading?: boolean;
};

export const ErrorAlertBanner = ({
  title,
  message,
  retryButtonText,
  onRetry,
  isRetryActionLoading = false
}: ErrorAlertBannerProps) => {
  const { t } = useTranslation();

  const buttonText = retryButtonText ?? t("retry");

  return (
    <ASDSThemeProvider>
      <AlertBanner
        severity="error"
        sx={{
          color: "black",
          maxWidth: 300,
          margin: "10px auto",
          fontSize: "0.875rem",
          padding: "0px 10px"
        }}
        skipCustomTypography
      >
        <Stack
          direction="column"
          spacing={1}
          role="region"
          aria-label="error banner content"
        >
          <Typography variant="subtitle1" fontWeight={500}>
            {title}
          </Typography>
          <Typography variant="body2">{message}</Typography>
          {onRetry && (
            <ProgressButton
              color="primary"
              onClick={onRetry}
              sx={{ marginTop: 1, borderRadius: "10px" }}
              loading={isRetryActionLoading}
            >
              {buttonText}
            </ProgressButton>
          )}
        </Stack>
      </AlertBanner>
    </ASDSThemeProvider>
  );
};
